import React from 'react';
import { Link } from 'react-router-dom';

import ListView from '../../components/ListView';

const ListPermissionSets = (props) => {
  const rows = [
    {id: 1, name: 'DS Develop'},
    {id: 2, name: 'DS Support'},
    {id: 3, name: 'DS Implementation'},
  ].map((ps) => ({...ps, actions: <Link to={`/o/permission-sets/edit/${ps.id}`}>edit</Link>}));

  return (
    <ListView
      count={100}
      pluralName="Permission Sets"
      singularName="Permission Set"
      match={props.match}

      currentPage={1}
      totalPages={1}
      rowKey="id"
      columns={[
        {label: null, key: 'actions', collapsing: true},
        {label: 'Name', key: 'name'},
      ]}
      rows={rows}
    />
  );
};

export default ListPermissionSets;
